/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { type AutocompleteOptionType, type AutocompleteOptionProps } from './types';
import type { SearchOasisDefinitionsViewModel } from '../../SearchOasisDefinitionsViewModel';
import type { SearchUserViewModel } from '../../SearchUserViewModel';
import type { SearchSupplyViewModel } from '../../SearchSupplyViewModel';
import type { SearchSupplierViewModel } from '../../SearchSupplierViewModel';
import type { SearchPhysicianViewModel } from '../../SearchPhysicianViewModel';
import type { SearchPhysicianGroupViewModel } from '../../SearchPhysicianGroupViewModel';
import type { SearchPharmacyViewModel } from '../../SearchPharmacyViewModel';
import type { SearchInsurancProviderPlansViewModel } from '../../SearchInsurancProviderPlansViewModel';
import type { SearchInsuranceProviderViewModel } from '../../SearchInsuranceProviderViewModel';
import type { SearchIcdDiagnosisViewModel } from '../../SearchIcdDiagnosisViewModel';
import type { SearchFacilityViewModel } from '../../SearchFacilityViewModel';
import type { SearchConceptViewModel } from '../../SearchConceptViewModel';
import type { SearchConceptCategoriesViewModel } from '../../SearchConceptCategoriesViewModel';
import type { SearchLegacyClinicianViewModel } from '../../SearchLegacyClinicianViewModel';
import type { SearchLegacyUserViewModel } from '../../SearchLegacyUserViewModel';
import type { SearchScheduleReportAssignedToViewModel } from '../../SearchScheduleReportAssignedToViewModel';
import type { SearchScheduleReportPatientViewModel } from '../../SearchScheduleReportPatientViewModel';
import type { SearchScheduleReportPrimaryInsuranceViewModel } from '../../SearchScheduleReportPrimaryInsuranceViewModel';
import type { SearchLegacyPatientsViewModel } from '../../SearchLegacyPatientsViewModel';
import type { SearchCareportFacilityViewModel } from '../../SearchCareportFacilityViewModel';
import type { SearchPatientViewModel } from '../../SearchPatientViewModel';
import type { SearchCertificationPeriodViewModel } from '../../SearchCertificationPeriodViewModel';
import type { SearchLaboratoryViewModel } from '../../SearchLaboratoryViewModel';
import type { SearchLabDefinitionViewModel } from '../../SearchLabDefinitionViewModel';
import type { SearchPatientPhysicianViewModel } from '../../SearchPatientPhysicianViewModel';
import type { SearchConceptDocumentationViewModel } from '../../SearchConceptDocumentationViewModel';
import type { SearchInterventionDefinitionsViewModel } from '../../SearchInterventionDefinitionsViewModel';
import type { SearchGoalDefinitionsViewModel } from '../../SearchGoalDefinitionsViewModel';

export type AutocompleteTypeToModel = {
	'all-concept-documentation': SearchConceptDocumentationViewModel;
	'all-facility': SearchFacilityViewModel;
	'all-lab-definition': SearchLabDefinitionViewModel;
	'all-laboratory': SearchLaboratoryViewModel;
	'all-patient-physician': SearchPatientPhysicianViewModel;
	'all-pharmacy': SearchPharmacyViewModel;
	'all-physician': SearchPhysicianViewModel;
	'all-physician-group': SearchPhysicianGroupViewModel;
	'all-supplier': SearchSupplierViewModel;
	'all-supply': SearchSupplyViewModel;
	'all-user': SearchUserViewModel;
	'allergy': SearchConceptCategoriesViewModel;
	'careport-facility': SearchCareportFacilityViewModel;
	'certification-period': SearchCertificationPeriodViewModel;
	'concept': SearchConceptViewModel;
	'concept-categories': SearchConceptCategoriesViewModel;
	'concept-documentation': SearchConceptDocumentationViewModel;
	'dme': SearchConceptCategoriesViewModel;
	'facility': SearchFacilityViewModel;
	'goal-definitions': SearchGoalDefinitionsViewModel;
	'icd-diagnosis': SearchIcdDiagnosisViewModel;
	'insuranc-provider-plans': SearchInsurancProviderPlansViewModel;
	'insurance-provider': SearchInsuranceProviderViewModel;
	'intervention-definitions': SearchInterventionDefinitionsViewModel;
	'lab-definition': SearchLabDefinitionViewModel;
	'laboratory': SearchLaboratoryViewModel;
	'legacy-clinician': SearchLegacyClinicianViewModel;
	'legacy-patients': SearchLegacyPatientsViewModel;
	'legacy-user': SearchLegacyUserViewModel;
	'oasis-definitions': SearchOasisDefinitionsViewModel;
	'patient': SearchPatientViewModel;
	'patient-physician': SearchPatientPhysicianViewModel;
	'pharmacy': SearchPharmacyViewModel;
	'physician': SearchPhysicianViewModel;
	'physician-group': SearchPhysicianGroupViewModel;
	'schedule-report-assigned-to': SearchScheduleReportAssignedToViewModel;
	'schedule-report-patient': SearchScheduleReportPatientViewModel;
	'schedule-report-primary-insurance': SearchScheduleReportPrimaryInsuranceViewModel;
	'supplier': SearchSupplierViewModel;
	'supply': SearchSupplyViewModel;
	'user': SearchUserViewModel;
};

const OasisDefinitionsAutocomplete: AutocompleteOptionProps<SearchOasisDefinitionsViewModel> = {
    searchType: 'oasis-definitions',
    endpoint: '_api/v1/homehealth/oasis/definitions/queries/searchoasisdefinitions/searchoasisdefinitions',
    valuePropKey: 'id',
    labelPropKey: 'title',
    defaultFilters: [],
    defaultSortColumn: 'title'
};
const UserAutocomplete: AutocompleteOptionProps<SearchUserViewModel> = {
    searchType: 'user',
    endpoint: '_api/v1/homehealth/libraries/users/queries/searchusers/searchuser',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllUserAutocomplete: AutocompleteOptionProps<SearchUserViewModel> = {
    searchType: 'all-user',
    endpoint: '_api/v1/homehealth/libraries/users/queries/searchusers/searchuser',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const SupplyAutocomplete: AutocompleteOptionProps<SearchSupplyViewModel> = {
    searchType: 'supply',
    endpoint: '_api/v1/homehealth/libraries/supplies/queries/searchsupplies/searchsupply',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllSupplyAutocomplete: AutocompleteOptionProps<SearchSupplyViewModel> = {
    searchType: 'all-supply',
    endpoint: '_api/v1/homehealth/libraries/supplies/queries/searchsupplies/searchsupply',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const SupplierAutocomplete: AutocompleteOptionProps<SearchSupplierViewModel> = {
    searchType: 'supplier',
    endpoint: '_api/v1/suppliers/searchsupplier',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllSupplierAutocomplete: AutocompleteOptionProps<SearchSupplierViewModel> = {
    searchType: 'all-supplier',
    endpoint: '_api/v1/suppliers/searchsupplier',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const PhysicianAutocomplete: AutocompleteOptionProps<SearchPhysicianViewModel> = {
    searchType: 'physician',
    endpoint: '_api/v1/homehealth/libraries/physicians/queries/searchphysicians/searchphysician',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllPhysicianAutocomplete: AutocompleteOptionProps<SearchPhysicianViewModel> = {
    searchType: 'all-physician',
    endpoint: '_api/v1/homehealth/libraries/physicians/queries/searchphysicians/searchphysician',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const PhysicianGroupAutocomplete: AutocompleteOptionProps<SearchPhysicianGroupViewModel> = {
    searchType: 'physician-group',
    endpoint: '_api/v1/homehealth/libraries/physicians/queries/searchphysiciangroups/searchphysiciangroup',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'dateCreated'
};
const AllPhysicianGroupAutocomplete: AutocompleteOptionProps<SearchPhysicianGroupViewModel> = {
    searchType: 'all-physician-group',
    endpoint: '_api/v1/homehealth/libraries/physicians/queries/searchphysiciangroups/searchphysiciangroup',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'dateCreated'
};
const PharmacyAutocomplete: AutocompleteOptionProps<SearchPharmacyViewModel> = {
    searchType: 'pharmacy',
    endpoint: '_api/v1/homehealth/libraries/pharmacies/queries/searchpharmacies/searchpharmacy',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllPharmacyAutocomplete: AutocompleteOptionProps<SearchPharmacyViewModel> = {
    searchType: 'all-pharmacy',
    endpoint: '_api/v1/homehealth/libraries/pharmacies/queries/searchpharmacies/searchpharmacy',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const InsurancProviderPlansAutocomplete: AutocompleteOptionProps<SearchInsurancProviderPlansViewModel> = {
    searchType: 'insuranc-provider-plans',
    endpoint: '_api/v1/homehealth/libraries/insuranceproviders/queries/searchinsurancproviderplans/searchinsurancproviderplans',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const InsuranceProviderAutocomplete: AutocompleteOptionProps<SearchInsuranceProviderViewModel> = {
    searchType: 'insurance-provider',
    endpoint: '_api/v1/homehealth/libraries/insuranceproviders/queries/searchinsuranceproviders/searchinsuranceprovider',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const IcdDiagnosisAutocomplete: AutocompleteOptionProps<SearchIcdDiagnosisViewModel> = {
    searchType: 'icd-diagnosis',
    endpoint: '_api/v1/homehealth/libraries/icddiagnoses/queries/searchicddiagnoses/searchicddiagnosis',
    valuePropKey: 'id',
    labelPropKey: 'diagnosisLabel',
    defaultFilters: [],
    defaultSortColumn: 'diagnosisLabel'
};
const FacilityAutocomplete: AutocompleteOptionProps<SearchFacilityViewModel> = {
    searchType: 'facility',
    endpoint: '_api/v1/homehealth/libraries/facilities/queries/searchfacilities/searchfacility',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllFacilityAutocomplete: AutocompleteOptionProps<SearchFacilityViewModel> = {
    searchType: 'all-facility',
    endpoint: '_api/v1/homehealth/libraries/facilities/queries/searchfacilities/searchfacility',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const ConceptAutocomplete: AutocompleteOptionProps<SearchConceptViewModel> = {
    searchType: 'concept',
    endpoint: '_api/v1/homehealth/libraries/concepts/queries/searchconcepts/searchconcept',
    valuePropKey: 'id',
    labelPropKey: 'label',
    defaultFilters: [],
    defaultSortColumn: 'label'
};
const ConceptCategoriesAutocomplete: AutocompleteOptionProps<SearchConceptCategoriesViewModel> = {
    searchType: 'concept-categories',
    endpoint: '_api/v1/homehealth/libraries/concepts/queries/searchconceptcategories/searchconceptcategories',
    valuePropKey: 'id',
    labelPropKey: 'label',
    defaultFilters: [],
    defaultSortColumn: 'label'
};
const AllergyAutocomplete: AutocompleteOptionProps<SearchConceptCategoriesViewModel> = {
    searchType: 'allergy',
    endpoint: '_api/v1/homehealth/libraries/concepts/queries/searchconceptcategories/searchconceptcategories',
    valuePropKey: 'id',
    labelPropKey: 'label',
    defaultFilters: [{ name: 'allergy'}],
    defaultSortColumn: 'label'
};
const DmeAutocomplete: AutocompleteOptionProps<SearchConceptCategoriesViewModel> = {
    searchType: 'dme',
    endpoint: '_api/v1/homehealth/libraries/concepts/queries/searchconceptcategories/searchconceptcategories',
    valuePropKey: 'id',
    labelPropKey: 'label',
    defaultFilters: [{ name: 'dme'}],
    defaultSortColumn: 'label'
};
const LegacyClinicianAutocomplete: AutocompleteOptionProps<SearchLegacyClinicianViewModel> = {
    searchType: 'legacy-clinician',
    endpoint: '_api/v1/homehealth/legacy/users/searchlegacyclinician',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'id'
};
const LegacyUserAutocomplete: AutocompleteOptionProps<SearchLegacyUserViewModel> = {
    searchType: 'legacy-user',
    endpoint: '_api/v1/homehealth/legacy/users/searchlegacyuser',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const ScheduleReportAssignedToAutocomplete: AutocompleteOptionProps<SearchScheduleReportAssignedToViewModel> = {
    searchType: 'schedule-report-assigned-to',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportassignedto',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const ScheduleReportPatientAutocomplete: AutocompleteOptionProps<SearchScheduleReportPatientViewModel> = {
    searchType: 'schedule-report-patient',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportpatient',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const ScheduleReportPrimaryInsuranceAutocomplete: AutocompleteOptionProps<SearchScheduleReportPrimaryInsuranceViewModel> = {
    searchType: 'schedule-report-primary-insurance',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportprimaryinsurance',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const LegacyPatientsAutocomplete: AutocompleteOptionProps<SearchLegacyPatientsViewModel> = {
    searchType: 'legacy-patients',
    endpoint: '_api/v1/homehealth/legacy/patients/searchlegacypatients',
    valuePropKey: 'patientCode',
    labelPropKey: 'patientLabel',
    defaultFilters: [],
    defaultSortColumn: 'patientLabel'
};
const CareportFacilityAutocomplete: AutocompleteOptionProps<SearchCareportFacilityViewModel> = {
    searchType: 'careport-facility',
    endpoint: '_api/v1/homehealth/legacy/hospitalizations/searchcareportfacility',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const PatientAutocomplete: AutocompleteOptionProps<SearchPatientViewModel> = {
    searchType: 'patient',
    endpoint: '_api/v1/homehealth/intake/patients/queries/searchpatients/searchpatient',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const CertificationPeriodAutocomplete: AutocompleteOptionProps<SearchCertificationPeriodViewModel> = {
    searchType: 'certification-period',
    endpoint: '_api/v1/homehealth/intake/admissions/queries/searchcertificationperiods/searchcertificationperiod',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'certificationNumber'
};
const LaboratoryAutocomplete: AutocompleteOptionProps<SearchLaboratoryViewModel> = {
    searchType: 'laboratory',
    endpoint: '_api/v1/homehealth/frequencies/laboratories/queries/searchlaboratories/searchlaboratory',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'dateCreated'
};
const AllLaboratoryAutocomplete: AutocompleteOptionProps<SearchLaboratoryViewModel> = {
    searchType: 'all-laboratory',
    endpoint: '_api/v1/homehealth/frequencies/laboratories/queries/searchlaboratories/searchlaboratory',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'dateCreated'
};
const LabDefinitionAutocomplete: AutocompleteOptionProps<SearchLabDefinitionViewModel> = {
    searchType: 'lab-definition',
    endpoint: '_api/v1/homehealth/frequencies/definitions/queries/searchlabdefinitions/searchlabdefinition',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllLabDefinitionAutocomplete: AutocompleteOptionProps<SearchLabDefinitionViewModel> = {
    searchType: 'all-lab-definition',
    endpoint: '_api/v1/homehealth/frequencies/definitions/queries/searchlabdefinitions/searchlabdefinition',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const PatientPhysicianAutocomplete: AutocompleteOptionProps<SearchPatientPhysicianViewModel> = {
    searchType: 'patient-physician',
    endpoint: '_api/v1/homehealth/demographics/patientsphysicians/queries/searchpatientphysicians/searchpatientphysician',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [],
    defaultSortColumn: 'name'
};
const AllPatientPhysicianAutocomplete: AutocompleteOptionProps<SearchPatientPhysicianViewModel> = {
    searchType: 'all-patient-physician',
    endpoint: '_api/v1/homehealth/demographics/patientsphysicians/queries/searchpatientphysicians/searchpatientphysician',
    valuePropKey: 'id',
    labelPropKey: 'name',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'name'
};
const ConceptDocumentationAutocomplete: AutocompleteOptionProps<SearchConceptDocumentationViewModel> = {
    searchType: 'concept-documentation',
    endpoint: '_api/v1/homehealth/concepts/queries/searchconceptdocumentation/searchconceptdocumentation',
    valuePropKey: 'id',
    labelPropKey: 'conceptLabel',
    defaultFilters: [],
    defaultSortColumn: 'conceptLabel'
};
const AllConceptDocumentationAutocomplete: AutocompleteOptionProps<SearchConceptDocumentationViewModel> = {
    searchType: 'all-concept-documentation',
    endpoint: '_api/v1/homehealth/concepts/queries/searchconceptdocumentation/searchconceptdocumentation',
    valuePropKey: 'id',
    labelPropKey: 'conceptLabel',
    defaultFilters: [{ name: 'activeOnly'}],
    defaultSortColumn: 'conceptLabel'
};
const InterventionDefinitionsAutocomplete: AutocompleteOptionProps<SearchInterventionDefinitionsViewModel> = {
    searchType: 'intervention-definitions',
    endpoint: '_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/searchinterventiondefinitions/searchinterventiondefinitions',
    valuePropKey: 'id',
    labelPropKey: 'title',
    defaultFilters: [],
    defaultSortColumn: 'title'
};
const GoalDefinitionsAutocomplete: AutocompleteOptionProps<SearchGoalDefinitionsViewModel> = {
    searchType: 'goal-definitions',
    endpoint: '_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/searchgoaldefinitions/searchgoaldefinitions',
    valuePropKey: 'id',
    labelPropKey: 'title',
    defaultFilters: [],
    defaultSortColumn: 'title'
};


export function GetAutocompleteProps<K extends AutocompleteOptionType>(type: K): AutocompleteOptionProps<AutocompleteTypeToModel[K]> {
	switch (type) 
	{
		case 'oasis-definitions':
			return OasisDefinitionsAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'user':
			return UserAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-user':
			return AllUserAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'supply':
			return SupplyAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-supply':
			return AllSupplyAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'supplier':
			return SupplierAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-supplier':
			return AllSupplierAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'physician':
			return PhysicianAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-physician':
			return AllPhysicianAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'physician-group':
			return PhysicianGroupAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-physician-group':
			return AllPhysicianGroupAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'pharmacy':
			return PharmacyAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-pharmacy':
			return AllPharmacyAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'insuranc-provider-plans':
			return InsurancProviderPlansAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'insurance-provider':
			return InsuranceProviderAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'icd-diagnosis':
			return IcdDiagnosisAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'facility':
			return FacilityAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-facility':
			return AllFacilityAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'concept':
			return ConceptAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'concept-categories':
			return ConceptCategoriesAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'allergy':
			return AllergyAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'dme':
			return DmeAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'legacy-clinician':
			return LegacyClinicianAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'legacy-user':
			return LegacyUserAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'schedule-report-assigned-to':
			return ScheduleReportAssignedToAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'schedule-report-patient':
			return ScheduleReportPatientAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'schedule-report-primary-insurance':
			return ScheduleReportPrimaryInsuranceAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'legacy-patients':
			return LegacyPatientsAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'careport-facility':
			return CareportFacilityAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'patient':
			return PatientAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'certification-period':
			return CertificationPeriodAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'laboratory':
			return LaboratoryAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-laboratory':
			return AllLaboratoryAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'lab-definition':
			return LabDefinitionAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-lab-definition':
			return AllLabDefinitionAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'patient-physician':
			return PatientPhysicianAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-patient-physician':
			return AllPatientPhysicianAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'concept-documentation':
			return ConceptDocumentationAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'all-concept-documentation':
			return AllConceptDocumentationAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'intervention-definitions':
			return InterventionDefinitionsAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		case 'goal-definitions':
			return GoalDefinitionsAutocomplete as AutocompleteOptionProps<AutocompleteTypeToModel[K]>;
		default:
			throw Error('Unable to determine autocomplete type');
	}
}